import { Logo } from '../../atoms'
import { useI18n } from '../../../../i18n/i18n'
import './footer.scss'

export function Footer() {
  const { t } = useI18n()
  return (
    <div className="container__footer">
      <div className="brand__footer">
        <Logo />
        <p className="tagline__footer">{t('footer.tagline')}</p>
      </div>

      <div className="contacts__footer">
        <p><a href={`mailto:${t('footer.email')}`}>{t('footer.email')}</a></p>
        <p>{t('footer.phone')}</p>
        <p>{t('footer.local')}</p>
        <p>{t('footer.cnpj')}</p>
      </div>
    </div>
  )
}
